import { render, staticRenderFns } from "./liveevents.vue?vue&type=template&id=bbd5720c&scoped=true&"
import script from "./liveevents.vue?vue&type=script&lang=ts&"
export * from "./liveevents.vue?vue&type=script&lang=ts&"
import style0 from "./liveevents.vue?vue&type=style&index=0&id=bbd5720c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd5720c",
  null
  
)

export default component.exports